export const SET_ERROR_MESSAGES_PRT = 'SET_ERROR_MESSAGES_PRT';
export const SET_SUCCESS_MESSAGES = 'SET_SUCCESS_MESSAGES';
export const SET_PLAN_TYPE = 'SET_PLAN_TYPE';
export const SET_SELECT_TYPE = 'SET_SELECT_TYPE';
export const SET_REBATE_PROGRAM = 'SET_REBATE_PROGRAM';
export const SET_START_DATE = 'SET_START_DATE';
export const SET_END_DATE = 'SET_END_DATE';
export const SET_ERRORS = 'SET_ERRORS';
export const SET_REBATE_LIST = 'SET_REBATE_LIST';
export const RESET_PERIODIC_REPORT_STORE = 'RESET_PERIODIC_REPORT_STORE';
export const SET_NEWORK_ERROR = 'SET_NEWORK_ERROR';
